import type { ReactNode } from 'react';

/** Numbered step heading inside a generator panel. */
export function StepTitle({ index, children, aside }: { index: number; children: ReactNode; aside?: ReactNode }) {
  return (
    <div className="mb-4 flex items-center justify-between gap-3">
      <h3 className="flex items-center gap-2 text-sm font-semibold text-foreground">
        <span className="flex size-6 items-center justify-center rounded-full bg-primary text-xs font-bold text-primary-foreground">
          {index}
        </span>
        {children}
      </h3>
      {aside}
    </div>
  );
}
